import { Container, Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { FormStep } from '../MultiStepForm';
import RadioField from '../RadioField';

export default function Authorization(props: {
    onSubmit: any;
    formError: any;
    validationSchema: any;
}) {
    const { onSubmit, formError, validationSchema } = props;
    return (
        <FormStep
            stepName="authorization"
            onSubmit={onSubmit}
            formError={formError}
            validationSchema={validationSchema}
        >
            <Container>
                <VStack alignItems="center">
                    <Heading mb="24px" fontWeight={800}>
                        Some important legal questions
                    </Heading>
                    <Text fontWeight={500} fontSize="18px" lineHeight="24px">
                        Are you legally authorized to work in the United States?
                    </Text>
                    <Flex w="530px">
                        <RadioField
                            name="authorization"
                            type="radio"
                            text="Yes"
                            value="Yes"
                            align="left"
                            topMargin="6px"
                        />
                        <RadioField
                            name="authorization"
                            type="radio"
                            text="No"
                            value="No"
                            align="right"
                            topMargin="6px"
                        />
                    </Flex>
                </VStack>
                <VStack alignItems="center" mt="28px">
                    <Text fontWeight={500} fontSize="18px" lineHeight="24px">
                        Will you now or in the future require a visa sponsorship to work in the
                        United States?
                    </Text>
                    <Flex w="530px">
                        <RadioField
                            name="needVisa"
                            type="radio"
                            text="Yes"
                            value="Yes"
                            align="left"
                            topMargin="6px"
                        />
                        <RadioField
                            name="needVisa"
                            type="radio"
                            text="No"
                            value="No"
                            align="right"
                            topMargin="6px"
                        />
                    </Flex>
                </VStack>
            </Container>
        </FormStep>
    );
}
